import { FILTER_OPTION_TYPE } from './enum';

/**
 * General Filter Option Config
 */

const defaultMultiSelectOptionItem = [
  FILTER_OPTION_TYPE?.PERCENT_SALE || 'percent_sale',
  FILTER_OPTION_TYPE?.STOCK || 'stock',
];

export const isMultiSelectOptionItemByDefault = (filterType: FILTER_OPTION_TYPE) => {
  return defaultMultiSelectOptionItem.includes(filterType);
};
